export class OMSCartDataModel {
    products: Object[]
    imageList: Object[]
    medications: Object[]
    note: String;
    constructor(medcines: Object[], products: Object[],
        imageList: Object[], instructions: String) {
        this.products = products;
        this.imageList = imageList;
        this.medications = medcines;
        this.note = instructions;
    }
}